/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const createStoryDataSchema = z.object({
	id: z.string().uuid().nullable().optional(),
	imageId: z.string().uuid().nullable().optional(),
	campaignId: z.string().uuid(),
	organisationId: z.string().uuid(),
	title: z.string(),
	subtitle: z.string(),
	button: z.string(),
	location: z.string(),
	meta: z.record(z.string(), z.unknown()).nullable().optional(),
	metaTitle: z.string().nullable().optional(),
	metaDescription: z.string().nullable().optional(),
	metaCallToAction: z.string().nullable().optional(),
	metaPrimaryText: z.string().nullable().optional(),
})

export type CreateStoryDataSchema = z.infer<typeof createStoryDataSchema>
